export const USER_ERROR_MESSAGES = {
  // Operation Erros
  INVALID_DATA: 'Invalid user data or no token provided',
  INVALID_REQUEST: 'Invalid request format',

  // Authorization Errors
  UNAUTHORIZED: 'Unauthorized to perform this action',
  FORBIDDEN: 'Access forbidden',
  NOT_FOUND: 'User profile not found',

  // Other Errors
  ALREADY_EXISTS: 'User profile already exists',
  SERVER_ERROR: 'Server error occurred',
} as const;
